import { useEffect, useState } from "react";
import { getFormPrefixList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

// Distinct FormPrefixCode values from /lookup/GetFormPrefixList — same shape
// as the Policy Inventory Lookup tab's Prefix dropdown. Codes are numeric on
// the wire; stringified here so the option value plays nicely with
// serializeFilters' CSV joining.
export function useFormPrefixOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getFormPrefixList().then((rows) => {
      if (!mounted) return;
      const seen = new Set<string>();
      const opts: OptionRenderType[] = [];
      for (const r of rows) {
        const v = r.FormPrefixCode == null ? "" : String(r.FormPrefixCode);
        if (!v || seen.has(v)) continue;
        seen.add(v);
        opts.push({ label: v, value: v });
      }
      setOptions(opts);
    });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}
